import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import axios from 'axios';
import { Dispatch, SetStateAction } from 'react';
import { ErrorToast, SuccessToast } from '../components';
import { getMyWebinarTickets } from '../views/WebinarTickets/WebinarTickets.actions';
import { WebinarsSteps } from '../views/Webinars/Webinars';

export const getWebinars = createAsyncThunk('auth/getWebinars', async () => {
  try {
    const { data } = await axios.get(`/webinars`);

    return data.data.reverse();
  } catch (error) {
    console.log(error);
  }
});

export const purchaseWebinarTicket = createAsyncThunk(
  'auth/purchaseWebinarTicket',
  async (
    {
      webinarId,
      token,
      setStep
    }: {
      webinarId: number;
      token: string;
      setStep: any;
    },
    { rejectWithValue, dispatch }
  ) => {
    try {
      const { data } = await axios.post(`/webinars`, {
        webinarId,
        currency: token === 'USDT' ? 'usdt' : 'usdc',
        network: 1
      });

      dispatch(getWebinars());

      setStep(WebinarsSteps.SUCCESS);

      return data.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data.error);
    }
  }
);

export const getWebinarsMenagement = createAsyncThunk(
  'auth/getWebinarsMenagement',
  async () => {
    try {
      const { data } = await axios.get(`/webinar-management`);

      return data.data;
    } catch (error) {
      console.log(error);
    }
  }
);

export const createWebinarMenagement = createAsyncThunk(
  'auth/createWebinarMenagement',
  async (
    {
      name,
      description,
      ticketPrice,
      numberOfTickets,
      date,
      setIsSideModalOpen
    }: {
      name: string;
      description: string;
      ticketPrice: any;
      numberOfTickets: any;
      date: string;
      setIsSideModalOpen: any;
    },
    { rejectWithValue, dispatch }
  ) => {
    try {
      const { data } = await axios.post(`/webinar-management`, {
        name,
        description,
        ticketPrice,
        numberOfTickets,
        dateStart: date
      });

      setIsSideModalOpen(false);

      dispatch(getWebinarsMenagement());

      return data.data;
    } catch (error) {
      console.log(error);
    }
  }
);

export const editWebinarMenagement = createAsyncThunk(
  'auth/editWebinarMenagement',
  async (
    {
      id,
      name,
      description,
      ticketPrice,
      numberOfTickets,
      date,
      setIsEditModalOpen
    }: {
      id: number;
      name: string;
      description: string;
      ticketPrice: any;
      numberOfTickets: any;
      date: string;
      setIsEditModalOpen: any;
    },
    { rejectWithValue, dispatch }
  ) => {
    try {
      const { data } = await axios.put(`/webinar-management/${id}`, {
        name,
        description,
        ticketPrice,
        numberOfTickets,
        dateStart: date
      });

      setIsEditModalOpen(false);

      dispatch(getWebinarsMenagement());

      return data.data;
    } catch (error) {
      console.log(error);
    }
  }
);

export interface WebinarTicket {
  ticketId: number;
  webinarId: number;
  webinarName: string;
  dateStart: string;
  ticketPrice: number;
  datePaid: string;
  zoomMeetingId: string;
  zoomJoinUrl: string;
  nftId: number;
}
export interface accountingSliceType {
  loading: boolean;
  webinars: [];
  webinarsMenagement: [];
  webinarTickets: WebinarTicket[];
  webinar: any;
}

const initialState = {
  loading: false,
  webinars: [],
  webinarsMenagement: [],
  webinarTickets: [],
  webinar: null
} as accountingSliceType;

const webinarSlice = createSlice({
  name: 'webinars',
  initialState,
  reducers: {
    // removeOrdersState(state) {
    //   state = initialState;
    // }
  },

  extraReducers: (builder) => {
    //get
    builder.addCase(getWebinars.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(getWebinars.fulfilled, (state, { payload }) => {
      state.loading = false;
      state.webinars = payload;
    });
    builder.addCase(getWebinars.rejected, (state) => {
      state.loading = false;
    });

    //create
    builder.addCase(purchaseWebinarTicket.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(purchaseWebinarTicket.fulfilled, (state, { payload }) => {
      state.loading = false;
      state.webinar = payload;
    });
    builder.addCase(purchaseWebinarTicket.rejected, (state) => {
      state.loading = false;
    });

    //get
    builder.addCase(getWebinarsMenagement.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(getWebinarsMenagement.fulfilled, (state, { payload }) => {
      state.loading = false;
      state.webinarsMenagement = payload;
    });
    builder.addCase(getWebinarsMenagement.rejected, (state) => {
      state.loading = false;
    });

    //create
    builder.addCase(createWebinarMenagement.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(createWebinarMenagement.fulfilled, (state, { payload }) => {
      state.loading = false;
      // state.webinars = payload;
    });
    builder.addCase(createWebinarMenagement.rejected, (state) => {
      state.loading = false;
    });

    //edit
    builder.addCase(editWebinarMenagement.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(editWebinarMenagement.fulfilled, (state, { payload }) => {
      state.loading = false;
      // state.webinars = payload;
    });
    builder.addCase(editWebinarMenagement.rejected, (state) => {
      state.loading = false;
    });

    //webinar tickets
    builder.addCase(getMyWebinarTickets.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(getMyWebinarTickets.fulfilled, (state, { payload }) => {
      state.loading = false;
      state.webinarTickets = payload;
    });

    builder.addCase(getMyWebinarTickets.rejected, (state) => {
      state.loading = false;
    });
  }
});

// export const { removeOrdersState } = webinarSlice.actions;

export default webinarSlice.reducer;
